


















































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import RefreshPageClass from "@/utility/RefreshPageClass";
import EncounterIndex from "@/store/modules/EncounterIndex";
import { ServicedPasien } from "@/store/modules/EncounterIndex";
import { userModule } from "@/store/modules/user";

@Component({})
export default class TheNavigationDrawer extends Vue {
  @Prop() items!: Array<any>;
  @Prop() activeItem = "";

  rpc = null;

  public drawer = window.innerWidth > 960;
  public subtitle = "Rekam Medis Elektronik RSUD Panembahan Senopati";
  isMini = true;
  expandListPasien = false;

  get currentVersionHash() {
    return this.rpc?.currentHash;
  }

  get pasiens(): ServicedPasien[] {
    return EncounterIndex.servicedPasien;
  }

  get listPasien() {
    return Object.values(
      this.pasiens
        .slice()
        .sort((a, b) => {
          return (
            Number(a.accepted_konsul === true) -
            Number(b.accepted_konsul === true)
          );
        })
        .reduce((acc, item) => {
          const unitNama = item.unit?.nama || "Tanpa Unit";
          // Jika unitNama belum ada, inisialisasi dengan objek { unitNama, items }
          if (!acc[unitNama]) {
            acc[unitNama] = { unitNama, items: [] };
          }
          // Tambahkan item ke array items
          acc[unitNama].items.push(item);
          return acc;
        }, {})
    );
  }

  namaPasien(item: ServicedPasien): string {
    return item?.pasien?.nama || `RM ${item?.pasien_rm || "-"}`;
  }

  get canShowMyPatient() {
    return parseInt(userModule.user.cdoc?.idsp) > 0;
  }

  @Watch("isMini")
  changeIsMini(val) {
    if (val) {
      this.expandListPasien = false;
    }
  }

  _getRole(id) {
    const mod = id % 3;
    if (mod === 0) {
      return "dpjp";
    } else if (mod === 1) {
      return "raber";
    } else {
      return "konsul";
    }
  }

  mounted() {
    this.rpc = new RefreshPageClass();

    if (this.canShowMyPatient) {
      EncounterIndex.getPasienRanapDilayani();
    }
  }

  handleNavigation(item) {
    if (item.link) {
      this.$emit("handleNavigation", item);
    }
  }
}
